export default "__VITE_ASSET__DYFHH_vC__"